/* eslint-disable import/prefer-default-export */
import api from '../api';

export function fetch(url) {
  return api.get(url);
}
